import * as React from "react";
import type { SVGProps } from "react";
export const SvgMiscPause = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 24 24" {...props}>
    <path fill="currentColor" d="M6 5h2v14H6V5Zm10 0h2v14h-2V5Z" />
  </svg>
);
